import { useQuery } from '@tanstack/react-query'
import axios, { AxiosHeaders, AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { UseQueryOptionsWithoutQueryKey } from '../../react-query-config'
import { Store } from 'components/common/filters/select-store'

interface StoreDto {
  country_id: string
  id: number
  label: string
  store_forecast: string
  currency_unit: string
  opening_date: string
  open: boolean
}

interface IStoresResponse {
  content: StoreDto[]
}

export const QUERY_KEY_STORES = 'get-stores'

const getStoresFn = async (config: InternalAxiosRequestConfig): Promise<Store[]> => {
  const response: AxiosResponse<IStoresResponse> = await axios(config)
  return response.data.content.map(item => {
    return {
      id: item.id,
      country_id: item.country_id,
      label: item.label,
      store_forecast: item.store_forecast,
      currency: item.currency_unit,
      opening_date: (item.opening_date && new Date(item.opening_date)) || null,
      is_open: item.open
    }
  })
}

export const useApiGetStores = (options?: UseQueryOptionsWithoutQueryKey<Store[]>) => {
  const url = '/stores'
  const config: InternalAxiosRequestConfig = { method: 'get', url, headers: new AxiosHeaders() }
  return useQuery<Store[], Error>({
    queryKey: [QUERY_KEY_STORES, url],
    queryFn: () => getStoresFn(config),
    staleTime: Infinity,
    ...options
  })
}
